import React from 'react'
import GradientText from './Animations/GradientText'
import BlurText from './Animations/BlurText'
import RoadmapSlider from './Roadmap-slider'

export default function Roadmapmain() {
    return (
        <div className='roadmap_main mt-20 md:p-10'>
            <div className='md:w-[70%] w-[90%] mx-auto lg:pl-20 flex flex-col items-center justify-center'>
                <div className='bg-black md:px-5 py-1 rounded-3xl w-fit md:mb-5 mb-2'>
                    <GradientText
                        colors={ ["#FF6972", "#D645D0", "#01B0DF",] }
                        animationSpeed={ 3 }
                        showBorder={ false }
                        className="font-semibold md:text-lg text-sm uppercase bg-black px-2 rounded-full py-1"
                    >
                        way forward
                    </GradientText>
                </div>
                <BlurText
                    text="Our Roadmap"
                    delay={ 300 }
                    animateBy="words"
                    direction="top"
                    className="md:text-5xl text-3xl font-medium !text-center md:mb-5 mb-2"
                />
            </div>
            <div className='md:block hidden'>
                <div className='grid grid-cols-2 lg:w-[80%] w-[90%] mx-auto mt-10'>
                    <div className='relative '>
                        <img src="/images/box-bg.png" alt="" className='w-[80%]' />
                        <div className='absolute p-5 top-10 left-5 w-[70%] space-y-4'>
                            <GradientText
                                colors={ ["#FF6972", "#D645D0", "#01B0DF",] }
                                animationSpeed={ 3 }
                                showBorder={ false }
                                className="font-semibold md:text-xl text-sm uppercase"
                            >
                                Phase 1:
                            </GradientText>
                            <h3 className='text-2xl font-semibold'>Token Launch & Foundational dApp Release</h3>
                            <ul className='list-disc font-normal space-y-1 opacity-80 pl-5'>
                                <li>Launch the $VOCAL token & begin community onboarding</li>
                                <li>Initiate marketing campaigns & engage early supporters</li>
                                <li>Release Vocal AI dApp V1 with core features: voice-to-text trading, limit orders, portfolio view</li>
                                <li>Conduct closed testing & refine based on early user feedback</li>
                                <li>Enable voice-based watchlists & contextual trade queries</li>
                            </ul>
                        </div>
                    </div>
                    <div className='relative'>
                        <img src="/images/box-bg.png" alt="" className='w-[80%]' />
                        <div className='absolute p-5 top-10 left-5 w-[70%] space-y-4'>
                            <GradientText
                                colors={ ["#FF6972", "#D645D0", "#01B0DF",] }
                                animationSpeed={ 3 }
                                showBorder={ false }
                                className="font-semibold md:text-xl text-sm uppercase"
                            >
                                Phase 3:
                            </GradientText>
                            <h3 className='text-2xl font-semibold'>Autonomous Agent Rollout & Advanced Automation</h3>
                            <ul className='list-disc font-normal space-y-1 opacity-80 pl-5'>
                                <li>Deploy Autonomous Trading via Voice Presets</li>
                                <li>Enable Portfolio Optimization & Automatic Rebalancing</li>
                                <li>Add Smart Routing & Real-Time Market Scanning</li>
                                <li>Expand Voice-Controlled Fund Management Features</li>
                                <li>Finalize UX/UI Across Desktop dApp</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <img src="/images/line.png" alt="" className='w-[80%] mx-auto mt-10' />
                <div className='grid grid-cols-2 lg:w-[80%] w-[90%] mx-auto mt-10'>
                    <div className='relative '>
                        <img src="/images/box-bg.png" alt="" className='w-[80%]' />
                        <div className='absolute p-5 top-10 left-5 w-[70%] space-y-4'>
                            <GradientText
                                colors={ ["#FF6972", "#D645D0", "#01B0DF",] }
                                animationSpeed={ 3 }
                                showBorder={ false }
                                className="font-semibold md:text-xl text-sm uppercase"
                            >
                                Phase 2:
                            </GradientText>
                            <h3 className='text-2xl font-semibold'>Smart Interaction & User Intelligence Layer</h3>
                            <ul className='list-disc font-normal space-y-1 opacity-80 pl-5'>
                                <li>Expand voice command capabilities for complex trade inputs</li>
                                <li>Add token sentiment analysis, gas fee tracking, & personalized alerts</li>
                                <li>Introduce portfolio rebalancing & performance summaries</li>
                                <li>Launch voice confirmations (PIN or biometric)</li>
                                <li>Activate simulated trading for user strategy testing</li>
                            </ul>
                        </div>
                    </div>
                    <div className='relative'>
                        <img src="/images/box-bg.png" alt="" className='w-[80%]' />
                        <div className='absolute p-5 top-10 left-5 w-[70%] space-y-4'>
                            <GradientText
                                colors={ ["#FF6972", "#D645D0", "#01B0DF",] }
                                animationSpeed={ 3 }
                                showBorder={ false }
                                className="font-semibold md:text-xl text-sm uppercase"
                            >
                                Phase 4:
                            </GradientText>
                            <h3 className='text-2xl font-semibold'>Ecosystem Expansion & Mobile Integration</h3>
                            <ul className='list-disc font-normal space-y-1 opacity-80 pl-5'>

                                <li>Begin Development of Vocal AI Mobile App</li>
                                <p>
                                    - Full Voice Trading Capabilities
                                    <br />
                                    - Biometric Security, Offline Fallback, Wearable Support
                                    <br />
                                    - Voice Activation & Command Chaining
                                </p>
                                <li>Release Developer SDK for Third-Party Integrations</li>
                                <li>Launch Ecosystem Growth Programs & Governance Utilities</li>
                                <li>Expand into Layer 2 Networks & Cross-Protocol Interoperability</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <RoadmapSlider />
        </div>
    )
}
